import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/modules/user/user.service';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'app-wtn-register-cta',
  templateUrl: './wtn-register-cta.component.html',
  styleUrls: ['./wtn-register-cta.component.scss']
})
export class WtnRegisterCtaComponent implements OnInit {
  @Input() wtnLink?: string = undefined
  buttonSize = 'medium';
  constructor(  private userService: UserService, public themeService: NbThemeService) { 
    
  }

  ngOnInit(): void {
    this.themeService.onMediaQueryChange().subscribe(([_, currentBreakpoint]) => {
      if (currentBreakpoint.width < 768) {
          this.buttonSize = 'small';
      } else {
          this.buttonSize = 'medium';
      }
  });
  }

  goToWtnLink()
  {
    if(this.wtnLink){  
      window.location.href = this.wtnLink
    }
  }

}
